

















import { Component, Mixins, Emit } from "vue-property-decorator";
import CardSelector from "./CardSelector.vue";
import { SingleOptionSelectableMixin } from "./mixins";

@Component({
  components: {
    selector: CardSelector,
  },
})
export default class OptionCardSelector extends Mixins(SingleOptionSelectableMixin) {
  @Emit("click")
  onClicked() {}
}
